module.exports = __webpack_public_path__ + "static/media/pz4.906b9e41.png";